<template>
  <div class="ProjectEdit__part">
    <div>
      <table
        class="table is-hoverable is-bordered is-fullwidth is-striped is-size-7"
      >
        <thead>
          <tr>
            <td>Type de surface</td>
            <td>
              <span style="display: flex"
                >Surface
                <span class="has-text-danger" style="margin-left: auto"
                  ><i class="fa fa-exclamation-circle"></i>&nbsp;sans unités,
                  ex: 14600</span
                ></span
              >
            </td>
            <td>suppr.</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(surf, index) in project.surfaces" :key="index">
            <td>
              <kv-suggestor
                :type="'surfaces'"
                :item="surf.surface_id"
                @update="update('surface_id', index, $event)"
                :inline="true"
              ></kv-suggestor>
            </td>
            <td><input type="text" class="input" v-model="surf.content" /></td>
            <td>
              <button class="button is-danger" @click="remove(index)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button class="button" @click="addRow">Ajouter une Surface</button>
      </div>
    </div>
  </div>
</template>
<script>
import KvSuggestor from "../../../components/Form/KvSuggestor";
import { cheapoClone } from "../../../util/func";
import { DefaultSurface } from "../../../store/models/project";

export default {
  name: "ProjectEdit-Surfaces",
  components: { KvSuggestor },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  methods: {
    update(key, index, value) {
      const p = cheapoClone(this.project);
      p.surfaces[index][key] = value;
      this.project = p;
    },
    addRow() {
      const p = cheapoClone(this.project);
      p.surfaces.push(DefaultSurface(this.project.id, null));
      this.project = p;
    },
    remove(index) {
      const p = cheapoClone(this.project);
      p.surfaces = p.surfaces.filter((a, i) => i !== index);
      this.project = p;
    }
  }
};
</script>
